var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { ref: "circle", staticClass: "d3-dot", style: _vm.svgStyle },
    [
      _c("circle", {
        staticStyle: { fill: "orange", opacity: "0.8" },
        attrs: { r: "4", cx: _vm.x, cy: _vm.yValues(_vm.y) }
      }),
      _c("circle", {
        staticStyle: { fill: "white" },
        attrs: { r: "2", cx: _vm.x, cy: _vm.yValues(_vm.y) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ec88b8c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ec88b8c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/evaluation_graph/d3_dot.vue
// module id = 593
// module chunks = 0